module.exports = __webpack_public_path__ + "media/images/icons/expander_down-07760a92335e10f2408adbe6de44c109.svg";